import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getNotificacaoEmails as getNotificacaoEmailsSdk,
  getNotificacaoEmail as getNotificacaoEmailSdk,
  postNotificacaoEmail as postNotificacaoEmailSdk,
  deleteNotificacaoEmail as deleteNotificacaoEmailSdk,
} from '@sdk/Conectores/Notificacao';

//Action Types
export const Types = {
  GET_NOTIFICACAO_EMAILS: 'GET_NOTIFICACAO_EMAILS',
  GET_NOTIFICACAO_EMAILS_SUCCESS: 'GET_NOTIFICACAO_EMAILS_SUCCESS',
  GET_NOTIFICACAO_EMAILS_ERROR: 'GET_NOTIFICACAO_EMAILS_ERROR',

  GET_NOTIFICACAO_EMAIL: 'GET_NOTIFICACAO_EMAIL',
  GET_NOTIFICACAO_EMAIL_SUCCESS: 'GET_NOTIFICACAO_EMAIL_SUCCESS',
  GET_NOTIFICACAO_EMAIL_ERROR: 'GET_NOTIFICACAO_EMAIL_ERROR',

  POST_NOTIFICACAO_EMAIL: 'POST_NOTIFICACAO_EMAIL',
  POST_NOTIFICACAO_EMAIL_SUCCESS: 'POST_NOTIFICACAO_EMAIL_SUCCESS',
  POST_NOTIFICACAO_EMAIL_ERROR: 'POST_NOTIFICACAO_EMAIL_ERROR',

  DELETE_NOTIFICACAO_EMAIL: 'DELETE_NOTIFICACAO_EMAIL',
  DELETE_NOTIFICACAO_EMAIL_SUCCESS: 'DELETE_NOTIFICACAO_EMAIL_SUCCESS',
  DELETE_NOTIFICACAO_EMAIL_ERROR: 'DELETE_NOTIFICACAO_EMAIL_ERROR',

  SET_NOTIFICACAO_EMAIL_CONECTORES_SELECIONADOS: 'SET_NOTIFICACAO_EMAIL_CONECTORES_SELECIONADOS',

  RESET: 'RESET',
};

//Action Creators
export const getNotificacaoEmails = (data) => ({ type: Types.GET_NOTIFICACAO_EMAILS, data });
export const getNotificacaoEmailsSuccess = (data) => ({ type: Types.GET_NOTIFICACAO_EMAILS_SUCCESS, data });
export const getNotificacaoEmailsError = (error) => ({ type: Types.GET_NOTIFICACAO_EMAILS_ERROR, error });

export const getNotificacaoEmail = (id) => ({ type: Types.GET_NOTIFICACAO_EMAIL, id });
export const getNotificacaoEmailSuccess = (data) => ({ type: Types.GET_NOTIFICACAO_EMAIL_SUCCESS, data });
export const getNotificacaoEmailError = (error) => ({ type: Types.GET_NOTIFICACAO_EMAIL_ERROR, error });

export const postNotificacaoEmail = (data) => ({ type: Types.POST_NOTIFICACAO_EMAIL, data });
export const postNotificacaoEmailSuccess = () => ({ type: Types.POST_NOTIFICACAO_EMAIL_SUCCESS });
export const postNotificacaoEmailError = (error) => ({ type: Types.POST_NOTIFICACAO_EMAIL_ERROR, error });

export const deleteNotificacaoEmail = (id) => ({ type: Types.DELETE_NOTIFICACAO_EMAIL, id });
export const deleteNotificacaoEmailSuccess = (id) => ({ type: Types.DELETE_NOTIFICACAO_EMAIL_SUCCESS, id });
export const deleteNotificacaoEmailError = (error) => ({ type: Types.DELETE_NOTIFICACAO_EMAIL_ERROR, error });

export const setConectoresSelecionados = (conectoresSelecionados) => ({
  type: Types.SET_NOTIFICACAO_EMAIL_CONECTORES_SELECIONADOS,
  conectoresSelecionados,
});

export const reset = () => ({ type: Types.RESET });

//saga
function* fetchGetNotificacaoEmails(action) {
  try {
    const data = yield call(getNotificacaoEmailsSdk);
    yield put(getNotificacaoEmailsSuccess(data));
  } catch (err) {
    Notification.error(err.message);
    yield put(getNotificacaoEmailsError(err));
  }
}

function* fetchGetNotificacaoEmail(action) {
  try {
    const data = yield call(getNotificacaoEmailSdk, action.id);
    yield put(getNotificacaoEmailSuccess(data));
  } catch (err) {
    Notification.error(err.message);
    yield put(getNotificacaoEmailError(err));
  }
}

function* fetchPostNotificacaoEmail(action) {
  try {
    const { data } = action;
    yield call(postNotificacaoEmailSdk, data);
    yield put(postNotificacaoEmailSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postNotificacaoEmailError(err));
  }
}

function* fetchDeleteNotificacaoEmail(action) {
  try {
    const { id } = action;
    yield call(deleteNotificacaoEmailSdk, id);
    yield put(deleteNotificacaoEmailSuccess(id));
  } catch (err) {
    Notification.error(err.message);
    yield put(deleteNotificacaoEmailError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_NOTIFICACAO_EMAILS, fetchGetNotificacaoEmails),
  takeLatest(Types.GET_NOTIFICACAO_EMAIL, fetchGetNotificacaoEmail),
  takeLatest(Types.POST_NOTIFICACAO_EMAIL, fetchPostNotificacaoEmail),
  takeLatest(Types.DELETE_NOTIFICACAO_EMAIL, fetchDeleteNotificacaoEmail),
];

// Reducer
const initialState = Map({
  emails: List(),
  loadingNotificacaoEmails: false,
  successNotificacaoEmails: false,
  errorNotificacaoEmails: false,

  email: {},
  loadingNotificacaoEmail: false,
  successNotificacaoEmail: false,
  errorNotificacaoEmail: false,

  postingNotificacaoEmail: false,
  successPostNotificacaoEmail: false,
  errorPostNotificacaoEmail: false,

  deletingNotificacaoEmail: false,
  successDeleteNotificacaoEmail: false,
  errorDeleteNotificacaoEmail: false,

  conectoresSelecionados: [],
});

const handleGetNotificacaoEmails = (state, action) => {
  return state.set('loadingNotificacaoEmails', true).set('successNotificacaoEmails', false).set('errorNotificacaoEmails', false);
};

const handleGetNotificacaoEmailsSuccess = (state, action) => {
  return state
    .set('emails', List(action.data))
    .set('loadingNotificacaoEmails', false)
    .set('successNotificacaoEmails', true)
    .set('errorNotificacaoEmails', false);
};

const handleGetNotificacaoEmailsError = (state, action) => {
  return state.set('loadingNotificacaoEmails', false).set('successNotificacaoEmails', false).set('errorNotificacaoEmails', action.error);
};

const handleGetNotificacaoEmail = (state, action) => {
  return state.set('loadingNotificacaoEmail', true).set('successNotificacaoEmail', false).set('errorNotificacaoEmail', false);
};

const handleGetNotificacaoEmailSuccess = (state, action) => {
  const email = action.data;

  let conectoresSelecionados = email[0].conectoresSelecionados.split(',');

  if (conectoresSelecionados[0] === '') conectoresSelecionados = [];

  return state
    .set('email', email[0])
    .set('loadingNotificacaoEmail', false)
    .set('successNotificacaoEmail', true)
    .set('errorNotificacaoEmail', false)
    .set('conectoresSelecionados', conectoresSelecionados);
};

const handleGetNotificacaoEmailError = (state, action) => {
  return state.set('loadingNotificacaoEmail', false).set('successNotificacaoEmail', false).set('errorNotificacaoEmail', action.error);
};

const handleConectoresSelecionados = (state, action) => {
  const { conectoresSelecionados } = action;
  return state.set('conectoresSelecionados', conectoresSelecionados);
};

const handlePostNotificacaoEmail = (state, action) => {
  return state.set('postingNotificacaoEmail', true).set('successPostNotificacaoEmail', false).set('errorPostNotificacaoEmail', false);
};

const handlePostNotificacaoEmailSuccess = (state, action) => {
  return state.set('postingNotificacaoEmail', false).set('successPostNotificacaoEmail', true).set('errorPostNotificacaoEmail', false);
};

const handlePostNotificacaoEmailError = (state, action) => {
  return state
    .set('postingNotificacaoEmail', false)
    .set('successPostNotificacaoEmail', false)
    .set('errorPostNotificacaoEmail', action.error);
};

const handleDeleteNotificacaoEmail = (state, action) => {
  return state.set('deletingNotificacaoEmail', true).set('successDeleteNotificacaoEmail', false).set('errorDeleteNotificacaoEmail', false);
};

const handleDeleteNotificacaoEmailSuccess = (state, action) => {
  const emails = state
    .get('emails')
    .toArray()
    .filter((email) => email.id !== action.id);
  return state
    .set('emails', List(emails))
    .set('deletingNotificacaoEmail', false)
    .set('successDeleteNotificacaoEmail', true)
    .set('errorDeleteNotificacaoEmail', false);
};

const handleDeleteNotificacaoEmailError = (state, action) => {
  return state
    .set('deletingNotificacaoEmail', false)
    .set('successDeleteNotificacaoEmail', false)
    .set('errorDeleteNotificacaoEmail', action.error);
};

const handleReset = (state, action) => {
  return initialState;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_NOTIFICACAO_EMAILS:
      return handleGetNotificacaoEmails(state, action);
    case Types.GET_NOTIFICACAO_EMAILS_SUCCESS:
      return handleGetNotificacaoEmailsSuccess(state, action);
    case Types.GET_NOTIFICACAO_EMAILS_ERROR:
      return handleGetNotificacaoEmailsError(state, action);

    case Types.GET_NOTIFICACAO_EMAIL:
      return handleGetNotificacaoEmail(state, action);
    case Types.GET_NOTIFICACAO_EMAIL_SUCCESS:
      return handleGetNotificacaoEmailSuccess(state, action);
    case Types.GET_NOTIFICACAO_EMAIL_ERROR:
      return handleGetNotificacaoEmailError(state, action);

    case Types.POST_NOTIFICACAO_EMAIL:
      return handlePostNotificacaoEmail(state, action);
    case Types.POST_NOTIFICACAO_EMAIL_SUCCESS:
      return handlePostNotificacaoEmailSuccess(state, action);
    case Types.POST_NOTIFICACAO_EMAIL_ERROR:
      return handlePostNotificacaoEmailError(state, action);

    case Types.DELETE_NOTIFICACAO_EMAIL:
      return handleDeleteNotificacaoEmail(state, action);
    case Types.DELETE_NOTIFICACAO_EMAIL_SUCCESS:
      return handleDeleteNotificacaoEmailSuccess(state, action);
    case Types.DELETE_NOTIFICACAO_EMAIL_ERROR:
      return handleDeleteNotificacaoEmailError(state, action);

    case Types.SET_NOTIFICACAO_EMAIL_CONECTORES_SELECIONADOS:
      return handleConectoresSelecionados(state, action);

    case Types.RESET:
      return handleReset(state, action);

    default:
      return state;
  }
}
